var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mylayout",staticClass:"dash-board"},[_c('div',[_c('Logo'),_c('Header')],1),_c('div',{staticClass:"content"},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }